import React from "react"
import PropTypes from "prop-types"
import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  Form,
} from "reactstrap"
import { withTranslation } from "react-i18next"

const ModalRetailerRequest = props => {
  const { modal, toggle, request } = props

  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle} tag="h4">
        {props.t("Retailer Request Details")}
      </ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col className="col-12">
              <div className="mb-3">
                <Label className="form-label">{props.t("Brand Name")}</Label>
                <Input
                  type="text"
                  value={request?.brandName || ""}
                  disabled
                />
              </div>
              <div className="mb-3">
                <Label className="form-label">{props.t("User Name")}</Label>
                <Input
                  type="text"
                  value={request?.userName || ""}
                  disabled
                />
              </div>
              <div className="mb-3">
                <Label className="form-label">{props.t("Email")}</Label>
                <Input
                  type="text"
                  value={request?.email || ""}
                  disabled
                />
              </div>
              <div className="mb-3">
                <Label className="form-label">{props.t("Phone")}</Label>
                <Input
                  type="text"
                  value={request?.phone || ""}
                  disabled
                />
              </div>
              <div className="mb-3">
                <Label className="form-label">{props.t("Address")}</Label>
                <Input
                  type="textarea"
                  value={request?.address || ""}
                  disabled
                  rows="3"
                />
              </div>
              <div className="mb-3">
                <Label className="form-label">{props.t("Services")}</Label>
                <Input
                  type="textarea"
                  value={request?.services || ""}
                  disabled
                  rows="4"
                />
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}

ModalRetailerRequest.propTypes = {
  toggle: PropTypes.func,
  modal: PropTypes.bool,
  request: PropTypes.object,
  t: PropTypes.any,
}

export default withTranslation()(ModalRetailerRequest)
